module.exports = __webpack_public_path__ + "img/noimage.6a09357f.png";